import { render, staticRenderFns } from "./RemoveView.vue?vue&type=template&id=56088f42&scoped=true&"
import script from "./RemoveView.vue?vue&type=script&lang=js&"
export * from "./RemoveView.vue?vue&type=script&lang=js&"
import style0 from "./RemoveView.vue?vue&type=style&index=0&id=56088f42&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56088f42",
  null
  
)

export default component.exports